import { memo } from 'react';
import { Eye, EyeOff } from 'lucide-react';

/**
 * Password Input Component with visibility toggle
 */
export const PasswordInputWithToggle = memo(
  ({
    label,
    value,
    onChange,
    placeholder,
    showPassword,
    onToggleVisibility,
    error,
    disabled,
    className = '',
  }) => {
    return (
      <div
        className={`content-stretch flex flex-col gap-[8px] items-start relative shrink-0 w-full ${className}`}
      >
        <p
          className="font-['Roboto:Regular',sans-serif] font-normal leading-[normal] relative shrink-0 text-[14px] text-black w-full"
          style={{ fontVariationSettings: "'wdth' 100" }}
        >
          {label}
        </p>
        <div className="relative w-full">
          <input
            type={showPassword ? 'text' : 'password'}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            disabled={disabled}
            className="bg-[#f2f4f8] h-[56px] rounded-[10px] w-full px-[16px] py-[18px] pr-[48px] font-['Roboto:Regular',sans-serif] font-normal text-[16px] text-black placeholder:text-[#6e6e71] border-none outline-none disabled:opacity-50"
            style={{ fontVariationSettings: "'wdth' 100" }}
          />
          <button
            type="button"
            onClick={onToggleVisibility}
            className="absolute right-[16px] top-1/2 -translate-y-1/2 bg-transparent border-none cursor-pointer p-0 text-[#6e6e71] hover:text-black"
            aria-label={showPassword ? 'Hide password' : 'Show password'}
          >
            {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
          </button>
        </div>
        {error && <p className="mt-1 text-[13px] text-red-600">{error}</p>}
      </div>
    );
  },
);

PasswordInputWithToggle.displayName = 'PasswordInputWithToggle';
